import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { AiOutlineClear } from 'react-icons/ai';
import { usePedidos } from '../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { FieldDropdown } from '../../../../themes/components/FieldDropdown';
import { useEffectOnce } from 'react-use';
import { Button } from '../../../../themes/components/Button';

export const BuscaPedidos = () => {
    let history = useHistory();
    const { buscarPedidos, situacoes, tiposPedidos } = usePedidos();
    const [numPedido, setNumPedido] = useState<string>("");
    const [codCliente, setCodCliente] = useState<string>("");
    const [situacao, setSituacao] = useState<string>("");
    const [tipoPedido, setTipoPedido] = useState<string>("");

    function handleBuscarPedido() {
        buscarPedidos(numPedido.trim(), codCliente.trim(), String(getCodSituacao(situacao.trim())), tipoPedido.length > 0 ? tipoPedido.trim().substring(0,1) : "", history);
    }

    //Buscando os pedidos na primeira vez que a tela abrir, ainda sem filtro;
    useEffectOnce(() => {
        buscarPedidos(numPedido.trim(), codCliente.trim(), situacao.trim(), tipoPedido.trim(), history);
    })

    function handleClearFields() {
        setSituacao("");
        setTipoPedido("");
        setCodCliente("");
        setNumPedido("");
    }

    function getCodSituacao(text:string){
        let sit = "";
        situacoes.forEach((opt) => {
            if(opt.nome === text){
                sit = opt.cod;
            }
        })
        return sit;
    }

    function getSituacaoList(){
        let temp: string[] = []
        situacoes.forEach((opt) => {
            temp.push(opt.nome)
        })
        return temp;
    }

    const handleChangeNumPedido = (event: React.ChangeEvent<{ value: unknown }>) => {
        setNumPedido(event.target.value as string);
    };

    const handleChangeCodigoCliente = (event: React.ChangeEvent<{ value: unknown }>) => {
        setCodCliente(event.target.value as string);
    };

    return (
        <div className="pedido-campo-busca">
            <form>
                <div className="form-row">
                    <div className="form-line">
                        <div className="form-group">
                            <label htmlFor="user">Número do Pedido</label>
                            <div className="pedido-linha-campo">
                                <input type="text" className="form-control" id="numPedido" name="numPedido" onChange={handleChangeNumPedido} value={numPedido} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="consulta-combobox-situacao-pedido">Situação do Pedido</label>
                            <div className="pedido-linha-campo">
                                <FieldDropdown
                                    value={situacao}
                                    id="consulta-combobox-situacao-pedido"
                                    options={getSituacaoList()}
                                    label={(option: string) => option}
                                    onChange={(event, newInputValue) => {
                                        setSituacao(newInputValue);
                                      }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-line">
                        <div className="form-group">
                            <label htmlFor="user">Cliente</label>
                            <div className="pedido-linha-campo">
                                <input type="text" className="form-control" id="cod-cliente" name="cod-cliente" onChange={handleChangeCodigoCliente} value={codCliente} placeholder="Código ou nome"/>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="consulta-combobox-tipo-pedido">Tipo do Pedido</label>
                            <div className="pedido-linha-campo">
                                <FieldDropdown
                                    value={tipoPedido}
                                    id="consulta-combobox-tipo-pedido"
                                    options={tiposPedidos}
                                    label={(option: string) => option}
                                    onChange={(event, newInputValue) => {
                                        setTipoPedido(newInputValue);
                                      }}
                                />
                            </div>
                        </div>                       
                    </div>
                    <div className="form-buttons">
                        <Button titleText="Pesquisar" classBtn="" onClick={() => handleBuscarPedido()} >
                            <FaSearch color="#444" style={{ marginBottom: '0.3em' }} />
                        </Button>
                        <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                            <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    )
}